<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsWorkflowNode'"
        :showCountControl="false"
        :showDisplayCountControl="false"
        :multiselect="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_P08', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    selectedNodeOption: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_NODE_ID'),
        datafield: 'nodeId',
      }, {
        text: this.$t('MSG_TXT_NODE_NM'),
        datafield: 'nodeName',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsWorkflowNode',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'workflowNodeUid', map: 'workflowNodeUid' },
      { type: 'string', name: 'workflowId', map: 'workflowId' },
      { type: 'string', name: 'nodeId', map: 'nodeId' },
      { type: 'string', name: 'nodeName', map: 'nodeName' },
      { type: 'string', name: 'nodeTypeCode', map: 'nodeTypeCode' },
      { type: 'string', name: 'nodeTypeName', map: 'nodeTypeName' },
      { type: 'string', name: 'buttonName', map: 'buttonName' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'pageId', map: 'pageId' },
      { type: 'string', name: 'dataServiceId', map: 'dataServiceId' },
      { type: 'string', name: 'workflowNodeParamList', map: 'workflowNodeParamList' },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.workflowId)) {
        this.setWorkflowNodeData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 워크플로우 노드 매핑 목록 조회
     */
    setWorkflowNodeData() {
      http.request(this.pageId, 'DTS_CMR_00029', {
        path: {
          'workflow-id': this.workflowId,
        },
      }).then(res => {
        utils.remove(res.data, index => utils.isEqual(index.workflowNodeUid, this.selectedNodeOption.key));

        this.dsWorkflowNode.submit();
        this.dsWorkflowNode.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * Button Event
     */
    onClickCancel() {
      this.$emit('popupClose');
    },
    onClickApply() {
      const selectedData = this.dsWorkflowNode.getSelectedRawData();
      if (selectedData.length > 0) {
        this.$emit('paramReturn', selectedData, 'selectedNodeInfo');
        this.$emit('popupClose');
      } else {
        // 선택 안했을 때
        utils.messageBox('information', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
  },
};
</script>
<style scoped>
</style>
